export function RelationshipLabelEditor({
  label,
  value,
  onChange,
  readonly = false,
}: {
  label: string;
  value: string;
  onChange(value: string): void;
  readonly?: boolean;
}) {
  return (
    <label style={{ display: 'grid', gap: 8 }}>
      <span style={{ fontSize: 12, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'rgba(180, 223, 255, 0.84)' }}>{label}</span>
      <textarea
        aria-label={label}
        disabled={readonly}
        onChange={(event) => onChange(event.target.value)}
        rows={3}
        style={{
          width: '100%',
          resize: 'vertical',
          borderRadius: 16,
          border: '1px solid rgba(180, 223, 255, 0.18)',
          background: 'rgba(3, 12, 28, 0.52)',
          color: 'rgba(239, 246, 255, 0.92)',
          padding: '12px 14px',
          font: 'inherit',
        }}
        value={value}
      />
    </label>
  );
}